// @flow

// takes in any date string and returns a date object
export default (date: string): Date => new Date(date);
